import React, { Component } from 'react';
export const WithMediaUpload = (store?: any) => {
    const OSS = window['OSS'];
    const AliyunUpload = window['AliyunUpload'];
    return (ComponentCon) => {
        class MediaUploadHoc extends Component<any, any> {
            public videoUploader: any;
            public aliyunHost: any;
            public client: any;
            public timer: any;
            public count: number = 0; // 统计图片上传队列
            constructor(props) {
                super(props);
                this.state = {
                    errorStatus: true,
                    errorContent: '',
                };
            }
            // 获取视频数据信息
            public getPlayInfo = (videoID) => {
                return new Promise((resolve, reject) => {
                    this.props.store.playInfo.init(videoID).then((res) => {
                        console.log('获取视频数据成功', res);
                        resolve(res);
                    }).catch((err) => {
                        reject(err);
                    });
                });
            }
            // 获取视频封面图
            public getSnapshots(videoId) {
                return new Promise((resolve, reject) => {
                    this.props.store.snapshots.init(videoId).then((res) => {
                        console.log('获取封面图成功', res);
                        resolve(res);
                    }).catch((err) => {
                        console.log('获取封面图失败', err);
                        reject(err);

                    });
                });

            }
            // 获取视频上传临时权限
            // tslint:disable-next-line:ban-types
            public getStsUpload = (target: any, fn: Function) => {
                this.props.store.stsUpload.init().then((res) => {
                    console.log('获取视频上传临时权限成功', res);
                    this.aliyunHost = res.host;
                    const ossParam = {
                        target,
                        accessKeyId: res.accessKeyId,
                        accessKeySecret: res.accessKeySecret,
                        securityToken: res.securityToken,
                        endpoint: res.endpoint,
                        bucketName: res.bucketName,
                    };
                    this.createVideoVodUpload(target, ossParam, fn);
                }).catch((err) => {
                    console.log('获取视频上传临时权限失败', err);
                    alert('视频上传失败');
                });
            }

            public createVideoVodUpload(file, STSTokenObj, fn) {
                const _self = this;
                this.setState({
                    errorStatus: false,
                    errorContent: '视频正在上传处理中',
                });
                this.videoUploader = new AliyunUpload.Vod({
                    // 分片大小默认1M，不能小于100K
                    partSize: 1048576,
                    // 并行上传分片个数，默认5
                    parallel: 5,
                    // 网络原因失败时，重新上传次数，默认为3
                    retryCount: 3,
                    // 网络原因失败时，重新上传间隔时间，默认为2秒
                    retryDuration: 2,
                    // 开始上传
                    onUploadstarted(uploadInfo) {
                        _self.videoUploader.setSTSToken(uploadInfo, STSTokenObj.accessKeyId, STSTokenObj.accessKeySecret, STSTokenObj.securityToken);
                    },
                    // 文件上传成功
                    onUploadSucceed(uploadInfo) {
                        clearInterval(this.timer);
                        if (uploadInfo.videoId) {
                            this.timer = setInterval(() => {
                                _self.getSnapshots(uploadInfo.videoId).then((res) => { // 获取截图信息
                                    _self.getPlayInfo(uploadInfo.videoId).then((playRes) => { // 获取视频信息
                                        _self.props.store.getImgInfoModel.init(res[0]).then((imgRes) => {
                                            _self.setState({
                                                errorStatus: true,
                                            });
                                            uploadInfo.pixel = '';
                                            uploadInfo.snapshots = res;
                                            uploadInfo.PlayInfo = playRes;
                                            fn(uploadInfo);
                                            clearInterval(this.timer);
                                        }).catch((err) => {
                                            _self.setState({
                                                errorStatus: true,
                                            });
                                            uploadInfo.pixel = err.ImageWidth.value + '*' + err.ImageHeight.value;
                                            uploadInfo.snapshots = res;
                                            uploadInfo.PlayInfo = playRes;
                                            fn(uploadInfo);
                                            clearInterval(this.timer);
                                        });
                                        /*  _self.setState({
                                             errorStatus: true,
                                         });
                                         uploadInfo.snapshots = res;
                                         uploadInfo.PlayInfo = playRes;
                                         fn(uploadInfo);
                                         clearInterval(this.timer); */
                                    });
                                    console.log('uploadInfo', uploadInfo);
                                }).catch((err) => {
                                    console.log('刚上传视频获取封面失败', err);
                                });
                            }, 2000);
                        }
                    },
                    // 文件上传失败
                    onUploadFailed(uploadInfo, code, message) {
                        console.log('onUploadFailed: file:' + uploadInfo.file.name + ',code:' + code + ', message:' + message);
                        alert('视频上传失败');
                        _self.setState({
                            errorStatus: true,
                        });
                    },
                    // 文件上传进度，单位：字节
                    onUploadProgress(uploadInfo, totalSize, loadedPercent) {
                        console.log('onUploadProgress:file:' + uploadInfo.file.name + ', fileSize:' + totalSize + ', percent:' + Math.ceil(loadedPercent * 100) + '%');
                    },
                    // 上传凭证超时
                    onUploadTokenExpired() {
                        console.log('onUploadTokenExpired');
                        // 上传方式1  实现时，根据uploadInfo.videoId调用刷新视频上传凭证接口重新获取UploadAuth
                        // uploader.resumeUploadWithAuth(uploadAuth);
                        // 上传方式2 实现时，从新获取STS临时账号用于恢复上传
                        // uploader.resumeUploadWithSTSToken(accessKeyId, accessKeySecret, secretToken, expireTime);
                    },
                    // 全部文件上传结束
                    onUploadEnd() {
                        console.log('onUploadEnd: uploaded all the files');
                    },
                });

                const userData: any = '{"Vod":{"StorageLocation":"","Title":"' + file.name + '","Description":"上传文本视频详情","CateId":"19","Tags":"tag1,tag2,标签3"}}';
                this.videoUploader.addFile(file, null, null, null, userData);

                this.videoUploader.startUpload();

            }
            // 获取图片上传临时权限
            public getStsWrite = (target: any, fn: any) => {
                this.count++;
                this.setState({
                    errorStatus: false,
                    errorContent: '图片正在上传处理中',
                });
                this.props.store.stsWrite.init().then((res) => {
                    console.log('获取临时图片上传写的权限成功', res);
                    this.aliyunHost = res.host;
                    const ossParam = {
                        target,
                        accessKeyId: res.accessKeyId,
                        accessKeySecret: res.accessKeySecret,
                        securityToken: res.securityToken,
                        endpoint: res.endpoint,
                        bucketName: res.bucketName,
                        videoUploadInfo: {},
                    };
                    this.checkOss(ossParam, fn);
                }).catch((err) => {
                    console.log('获取临时图片上传写的权限失败', err);
                    this.setState({
                        errorStatus: true,
                    });
                    alert('图片上传失败');
                });
            }
            public checkOss = (ossParam, fn) => {
                const endpointItem = ossParam.endpoint.indexOf('https') > -1 ? ossParam.endpoint : ossParam.endpoint.replace('http', 'https');
                this.client = new OSS.Wrapper({
                    accessKeyId: ossParam.accessKeyId,
                    accessKeySecret: ossParam.accessKeySecret,
                    stsToken: ossParam.securityToken,
                    endpoint: endpointItem,
                    bucket: ossParam.bucketName,
                });
                this.multipartUpload(ossParam.target, fn);
            }
            public async multipartUpload(file, fn) {
                try {
                    const fileName = file.name;
                    const lastDotIndex = fileName.lastIndexOf('.');
                    const randomValue = (new Date()).getTime().toString().substr(4) + (Math.random() * 1000000).toFixed(0);
                    const newFileName = `lixiangzhizao_app/pc_push_system/${randomValue}.${fileName.substr(lastDotIndex + 1)}`;
                    const result = await this.client.multipartUpload(newFileName, file, {
                        headers: {
                            'Content-Disposition': `attachment; filename=${encodeURIComponent(file.name)}`,
                        },
                        mime: 'image/jpeg',
                    });
                    if (this.aliyunHost.substr(this.aliyunHost.length - 1) !== '/') {
                        this.aliyunHost = this.aliyunHost + '/';
                    }
                    result.url = this.aliyunHost + result.name;
                    // fn(result);
                    this.props.store.getImgInfoModel.init(result.url).then((res) => {
                        this.count--;
                        if (this.count <= 0) {
                            this.setState({
                                errorStatus: true,
                            });
                        }
                        fn(result);
                    }).catch((err) => {
                        this.count--;
                        if (this.count <= 0) {
                            this.setState({
                                errorStatus: true,
                            });
                        }
                        result.pixel = err.ImageWidth.value + '*' + err.ImageHeight.value;
                        fn(result);
                    });
                } catch (e) {
                    console.log('上传出错', e);
                    alert('图片上传失败');
                    this.setState({
                        errorStatus: true,
                    });
                }
            }
            public componentDidMount() {
                console.log('MediaUploadHoc');
            }
            public componentWillUnmount() {
                clearInterval(this.timer);
            }
            public render() {
                const newProps = {
                    getStsWrite: this.getStsWrite,
                    getStsUpload: this.getStsUpload,
                    ...this.props,
                    ...this.state,
                };
                return (
                    <ComponentCon {...newProps} />
                );
            }
        }
        return store ? store(MediaUploadHoc) : MediaUploadHoc;
    };
};
